/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTimer } from 'react-timer-hook';

function Timer({ time, timeFinish, timeProgress }) {
  const timeStamp = new Date();
  timeStamp.setSeconds(timeStamp.getSeconds() + time);

  const { hours, minutes, seconds } = useTimer({
    expiryTimestamp: timeStamp,
    onExpire: () => timeFinish(),
  });

  useEffect(() => {
    let totalSeconds = hours * 60 * 60;
    totalSeconds += minutes * 60;
    totalSeconds += seconds;
    timeProgress(totalSeconds);
  }, [hours, minutes, seconds]);

  return null;
}

Timer.propTypes = {
  time: PropTypes.number.isRequired,
  timeFinish: PropTypes.func.isRequired,
  timeProgress: PropTypes.func.isRequired,
};

export default Timer;
